package br.com.heyagenda.presentation.booking

import br.com.heyagenda.data.remote.AppointmentDto
import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.model.StudioService

data class PublicBookingUiState(
    val isLoading: Boolean = true,
    val isLoadingServices: Boolean = true,
    val notFound: Boolean = false,
    val resolvedUid: String? = null,
    val studioName: String = "",
    val professionalName: String = "",
    val specialty: String = "",
    val bio: String = "",
    val themeAccentColor: String? = null,
    val instagramHandle: String? = null,
    val address: String? = null,
    val announcementBanner: String? = null,
    val services: List<StudioService> = emptyList(),
    val selectedServices: Set<StudioService> = emptySet(),
    val selectedDateIso: String = "",
    val selectedDateText: String = "Hoje",
    val availableTimeSlots: List<String> = emptyList(),
    val existingAppointments: List<AppointmentDto> = emptyList(),
    val selectedTimeSlot: String? = null,
    val clientName: String = "",
    val clientPhone: String = "",
    val clientNotes: String = "",
    val paymentMethod: String = "",
    val isBookingModalOpen: Boolean = false,
    val isSubmitting: Boolean = false,
    val confirmedAppointment: Appointment? = null,
    val isPro: Boolean = false,
    val hasReachedMonthlyLimit: Boolean = false,
    val monthlyAppointmentsCount: Int = 0,
    val professionalPhone: String? = null,
    val submissionErrorMessage: String? = null
) {
    val selectedService: StudioService?
        get() = selectedServices.firstOrNull()

    val totalDurationMinutes: Int
        get() = selectedServices.sumOf { it.durationMinutes }.coerceAtLeast(15)

    val formattedDuration: String
        get() {
            val total = totalDurationMinutes
            val hours = total / 60
            val mins = total % 60
            return when {
                hours > 0 && mins > 0 -> "${hours}h ${mins}min"
                hours > 0 -> "${hours}h"
                else -> "${mins}min"
            }
        }

    val selectedServiceNames: String
        get() = if (selectedServices.isEmpty()) "" else selectedServices.joinToString(" + ") { it.name }

    val totalPriceFormatted: String
        get() {
            if (selectedServices.isEmpty()) return "R$ 0,00"
            var totalCents = 0L
            for (service in selectedServices) {
                val cleaned = service.priceFormatted
                    .replace("R$", "")
                    .replace(" ", "")
                    .replace(".", "")
                    .replace(",", ".")
                    .trim()
                val parsed = cleaned.toDoubleOrNull() ?: 0.0
                totalCents += (parsed * 100).toLong()
            }
            val reais = totalCents / 100
            val cents = totalCents % 100
            return "R$ $reais,${cents.toString().padStart(2, '0')}"
        }
}

